// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const BannerVendi: React.FC = () => {

    const { t } = useTranslation();

    const carouselImages = [
        "/assets/images/inHome/valutazione/valuta1.webp",
        "/assets/images/inHome/valutazione/valuta2.webp",
        "/assets/images/inHome/valutazione/valuta3.webp",
    ];

    const cariuselSettings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        pauseOnHover: false
    };

    return (
        <section className="valutazione space-pt">
            <div className="container-fluid">
                <div className="box-title">
                    <h2 dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.title') as string }} />
                    <p>
                        <span>{t('homePage.sellBanner.subTitle')}</span>
                    </p>
                    <div className="line"></div>
                </div>
            </div>
            <div className="bg-valuta">
                <Slider {...cariuselSettings}>
                    {carouselImages.map((image, index) => (
                        <div key={index} className="carousel-image-wrapper">
                            <img src={image} alt={`Slide ${index + 1}`} />
                        </div>
                    ))}
                </Slider>
                <div className="container text-center">
                    <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }} />
                    <Link className="btn btn-primary" to="/valutazione">
                        <span>{t('homePage.sellBanner.btnText')}</span>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default BannerVendi;